import { DataTable } from '../../../design-system/data-table/data-table';
import { BankFeedConnection, bankFeedsTableColumnDefinition } from './bank-feeds-table-column-definition';

type BankFeedsTableProps = {
  connections: BankFeedConnection[];
  onDisconnect: (connectionId: string) => void;
  onReconnect: (connectionId: string) => void;
  isDisconnecting?: boolean;
};

export const BankFeedsTable = ({
  connections,
  onDisconnect,
  onReconnect,
  isDisconnecting = false,
}: BankFeedsTableProps) => {
  return (
    <DataTable
      columns={bankFeedsTableColumnDefinition}
      data={connections}
      // No initialSorting - use backend sort order (Connected → Institution → Name → Currency)
      meta={{
        onDisconnect,
        onReconnect,
        isDisconnecting,
      }}
    />
  );
};
